<template>
   <div class="update-group container-fluid"> 
     <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
        <!-- Update Lesson Overlay -->
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-1Perc cursor-pointer" v-on:click="updateShowEditGroupOverlayFlag($event,false)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Group Name
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <input type="text" class="form-control" v-model="groupNameValue">
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  IsPublic
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px">
                      <input type="checkbox" class="float-left" v-model="getIsPublicValue"/>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Max Elective Enrollment Count
                </div>
                <div class="col-md-1 col-lg-1 padding-right-0Px">
                  <input type="number" placeholder="MAX" min="0" class="form-control" v-model="getMaxElectiveEnrollmentCount">
                </div>
                <div class="col-md-2 col-lg-2 padding-right-0Px"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Cohort Name
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px padding-right-0Px">
                      <input type="text" class="form-control" v-model="getCohortName" :disabled="getMaxElectiveEnrollmentCount === 0">
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>

            <hr width="94%" size="10px">
            <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-10 col-lg-10">
                  <b>LEAPS</b>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
            </div>

             <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Min Action Count
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <input type="number" placeholder="MAX" min="0" class="form-control" v-model="getMinActionCountValue">
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Max Action Count
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px padding-right-0Px">
                      <input type="number" placeholder="MAX" min="0" class="form-control" v-model="getMaxActionCountValue">
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
            </div>
            
              <hr width="94%" size="10px">
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Show Custom Unreleased Lesson Msg
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px">
                      <input type="checkbox" v-model="getShowUnreleasedModuleMessage"/>
                    </div>
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Unreleased Lesson Msg
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <input type="text" class="form-control" v-model="getUnreleasedModuleMessage" :maxlength="constants.Unrelease_Lesson_Msg_Max_Length" :disabled="!getShowUnreleasedModuleMessage">
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <hr width="94%" size="10px">

              <div class="row vertical-align margin-bottom-5Perc margin-top-5Perc" v-if="!showAddCertificateOption && !showExistingCerificateList">
                <div class="col-md-2 col-lg-2"></div> 
                <div class="col-md-4 col-lg-4">
                  <div class="row vertical-align">
                    <div class="col-md-12 col-lg-12">
                      <span class="glyphicon glyphicon-plus font-size-100px opacity-point-9 cursor-pointer" @click="performAction('AddCertificate')"></span>
                    </div> 
                  </div>
                  <div class="row vertical-align padding-top-1Perc cursor-pointer">
                    <div class="col-md-12 col-lg-12 font-size-17px font-weight-bold font-color-blue" @click="performAction('AddCertificate')">
                      Add New Certificate
                    </div> 
                  </div>
                </div> 
                <div class="col-md-4 col-lg-4">
                  <div class="row vertical-align">
                    <div class="col-md-12 col-lg-12">
                      <span class="glyphicon glyphicon-list-alt cursor-pointer font-size-100px font-weight-bold padding-top-3-Perc font-color-blue opacity-point-9" @click="performAction('ViewCertificates')"></span>
                    </div> 
                  </div>
                  <div class="row vertical-align padding-top-1Perc cursor-pointer">
                    <div class="col-md-12 col-lg-12 font-size-17px font-weight-bold font-color-blue" @click="performAction('ViewCertificates')">
                      View Existing List
                    </div> 
                  </div>
                </div> 
                <div class="col-md-2 col-lg-2"></div> 
              </div>

              <div class="row vertical-align margin-bottom-2Perc" v-if="showAddCertificateOption || showExistingCerificateList">
                <div class="col-md-1 col-lg-1"></div>
                <div class="font-size-15px col-md-2 col-lg-2 padding-left-0Px padding-right-0Perc text-align-left text-color-blue">
                  <span @click="performAction('BackToMenu')" class="text-color-blue cursor-pointer"> <u>< Back to Menu</u></span>
                </div>
                <div class="create-lesson-input-text-style col-md-6 col-lg-6 padding-right-0Perc font-size-21px text-color-orange">
                  View Existing List
                </div> 
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 padding-left-0Px padding-right-0Perc text-align-left">
                </div>
              </div>
              <create-certificate v-if="showAddCertificateOption" :selectedGroupObj="selectedGroupObj" :groupCourseList="getGroupCourseListValue" @updatedValues="updateNewValues" @showSpinner="emitShowSpinner"></create-certificate>
              <certificate-list v-if="showExistingCerificateList" :selectedGroupObj="selectedGroupObj" :groupCourseList="getGroupCourseListValue" :existingCertificateList="existingCertificateList" @updatedValues="updateNewValues" @showSpinner="emitShowSpinner"></certificate-list>
              
              <hr width="94%" size="10px">
              <div class="row margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px margin-top-2Perc">
                  Progress Buckets
                </div>
                <div class="col-md-8 col-lg-8">
                  <div class="form-group">
                      <div class="col-sm-12 col-md-12 col-lg-12">
                        <edit-progress-bucket v-bind:updateGroupBtnClicked="IsUpdateGroupBtnPressed" v-bind:ProgressBucketArr="currentProgressBuckets" :selectedGroupCourseIds="selectedGroupCourseIds" @addBuckets="addBuckets" v-bind:groupObj="groupObj"></edit-progress-bucket>
                      </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-4 col-lg-4">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="getProgressBuckets">Update</button>
                </div>  
                <div class="col-md-2 col-lg-2 padding-right-0Px">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color padding-6px-7px" @click="askUserConfirmation($event, 'delete_buckets')">Delete all buckets</button>
                </div>
                <div class="col-md-4 col-lg-4"></div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postfixString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="userConfirmationAction"></confirmation-alert>
    </div> 
</template>
<script>
import iconInfo from '../assets/images/iconinfoblue.png'
import { constants } from '@/utils/constants'
import { groupService } from '@/server-util/group-service'
import AlertBox from '@/components/AlertOverlay'
import EditProgressBucket from '@/components/EditProgressBucket'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import CreateCertificate from '@/components/group/CreateCertificate'
import CertificateList from '@/components/group/CertificateList'
import findIndex from 'lodash/findIndex'
export default {
  props: ['selectedGroupObj'],
  name: 'update-group',
  created () {
    this.setDefaultValues()
    this.getGroupCourseList()
    this.getAttachedExistingCertificateList()
  },
  data: function () {
    return {
      iconInfo: iconInfo,
      constants: constants,
      enableCertificationOption: true,
      showAddCertificateOption: false,
      showExistingCerificateList: false,
      groupObj: {
        GroupId: '',
        GroupName: '',
        M365Enabled: false,
        ProgressBuckets: [],
        M365CourseMasterId: '',
        IsPublic: false,
        GroupCourseMasterIds: [],
        AllowView: false,
        ShowUnreleasedModuleMessage: false,
        UnreleasedModuleMessage: '',
        MaxElectiveEnrollmentCount: 0,
        CohortName: '',
        MinActionCount: 0,
        MaxActionCount: 0
      },
      showAlertDialog: false,
      errorMsg: '',
      isUpdateBtnPressed: false,
      showConfirmationBox: false,
      prefixString: '',
      postfixString: '',
      selectedOperation: '',
      groupCourseList: [],
      selectedGroupCourseIds: [],
      existingCertificateList: []
    }
  },
  components: {
    'alert-box': AlertBox,
    'confirmation-alert': ConfirmationOverlay,
    'edit-progress-bucket': EditProgressBucket,
    'create-certificate': CreateCertificate,
    'certificate-list': CertificateList
  },
  methods: {
    updateNewValues (value) {
      const selectionOperation = value.currentOperation
      const updatedObj = value.certificateObj
      switch (selectionOperation) {
        case 'Close_Create_Certificate':
          this.showAddCertificateOption = false
          this.performAction('BackToMenu')
          break
        case 'Create_Certificate':
          this.existingCertificateList.push(updatedObj)
          this.performAction('BackToMenu')
          break
        case 'Update_Certificate':
          var foundIndex = findIndex(this.existingCertificateList, (obj) => {
            return obj.CertificateId === updatedObj.CertificateId
          })
          if (foundIndex > -1) {
            this.existingCertificateList[foundIndex] = updatedObj
          } else {
            this.existingCertificateList.push(updatedObj)
          }
          break
        case 'Delete_Certificate':
          foundIndex = findIndex(this.existingCertificateList, (obj) => {
            return obj.CertificateId === updatedObj.CertificateId
          })
          if (foundIndex > -1) {
            this.existingCertificateList.splice(foundIndex, 1)
          }
          break
      }
    },
    performAction: function (selectedOperationName) {
      switch (selectedOperationName) {
        case 'AddCertificate':
          this.showAddCertificateOption = true
          this.showExistingCerificateList = false
          break
        case 'ViewCertificates':
          this.showAddCertificateOption = false
          this.showExistingCerificateList = true
          break
        default:
        case 'BackToMenu':
          this.showAddCertificateOption = false
          this.showExistingCerificateList = false
          break
      }
    },
    titleToShow: function (grouCourseObj) {
      var titleToReturn = 'Akash'
      if (grouCourseObj.DisplayTitle !== undefined && grouCourseObj.DisplayTitle !== 'undefined' && grouCourseObj.DisplayTitle !== null && grouCourseObj.DisplayTitle !== 'null' && grouCourseObj.DisplayTitle !== '') {
        titleToReturn = grouCourseObj.DisplayTitle
        if (grouCourseObj.DisplaySubTitle !== undefined && grouCourseObj.DisplaySubTitle !== 'undefined' && grouCourseObj.DisplaySubTitle !== null && grouCourseObj.DisplaySubTitle !== 'null' && grouCourseObj.DisplaySubTitle !== '') {
          titleToReturn += ' [' + grouCourseObj.DisplaySubTitle + ']'
        }
      } else {
        if (grouCourseObj.CourseTitle !== undefined && grouCourseObj.CourseTitle !== 'undefined' && grouCourseObj.CourseTitle !== null && grouCourseObj.CourseTitle !== 'null' && grouCourseObj.CourseTitle !== '') {
          titleToReturn = grouCourseObj.CourseTitle
          if (grouCourseObj.CourseSubTitle !== undefined && grouCourseObj.CourseSubTitle !== 'undefined' && grouCourseObj.CourseSubTitle !== null && grouCourseObj.CourseSubTitle !== 'null' && grouCourseObj.CourseSubTitle !== '') {
            titleToReturn += ' [' + grouCourseObj.CourseSubTitle + ']'
          }
        }
      }
      return titleToReturn
    },
    userConfirmationAction (value) {
      this.showConfirmationBox = false
      if (value) {
        switch (this.selectedOperation) {
          case 'delete_buckets':
            // AK: delete progress buckets of selected group
            this.deleteAllBuckets()
            break
          case 'delete_certificate':
            // AK: delete certificate of selected group
            this.deleteSelectedCertificate()
            break
        }
      }
    },
    deleteAllBuckets () {
      var _this = this
      var storeObj = this.$store
      if (this.selectedGroupObj !== undefined || this.selectedGroupObj.length > 0) {
        // AK: Start Showing Spinner (ManageGroup file)
        _this.$emit('showSpinner', true)
        groupService
            .deleteAllProgressBuckets(storeObj.state.access_token, _this.groupObj.GroupId)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Refresh Group List
                _this.$emit('refreshGroupList', true)
                _this.$emit('showEditGroupOverlay', false)
              } else {
                _this.isUpdateBtnPressed = false
                // AK: Hide Spinner
                _this.$emit('showSpinner', false)
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              _this.isUpdateBtnPressed = false
              _this.$emit('showSpinner', false)
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
      } else {
        console.log(
          'Selected Group Object is NULL hence declined DELETE PROGRESS BUCKET OPERATION'
        )
      }
    },
    getGroupCourseList () {
      var _this = this
      var storeObj = this.$store
      if (this.selectedGroupObj !== undefined) {
        groupService
            .getCourseList(storeObj.state.access_token, _this.selectedGroupObj.GroupId)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                _this.groupCourseList = responseObj.data
              } else {
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
      } else {
        console.log(
          'Selected Group Object is NULL hence declined LOADING GROUP COURSE LIST OPERATION'
        )
      }
    },
    getAttachedExistingCertificateList () {
      var _this = this
      var storeObj = this.$store
      if (this.selectedGroupObj !== undefined) {
        groupService
            .getAttachedCertificateList(storeObj.state.access_token, _this.selectedGroupObj.GroupId)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                _this.existingCertificateList = responseObj.data
              } else {
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
      } else {
        console.log(
          'Selected Group Object is NULL hence declined LOADING ATTACHED CERTIFICATE LIST TO CURRENT GROUP OPERATION'
        )
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
    },
    addBuckets (value) {
      // AK: If all conditions are fullfilled then issue server call
      if (value) {
        // console.log('CALLED TO UPDATE.')
        this.groupObj.ProgressBuckets = this.$store.state.createProgressBuckets
        // console.log('this.groupObj.ProgressBuckets >>> ' + JSON.stringify(this.groupObj))
        this.updateGroupDetails()
      } else {
        // AK: Reset flag to original in order to get watch event on isUpdateBtnPressed in (EditProgressBucket file)
        // Since for same value, event does not emit
        this.isUpdateBtnPressed = false
        // console.log('ALL UPDATE GROUP CONDITIONS ARE NOT FULLFILLED.')
      }
    },
    getProgressBuckets: function () {
      // AK: Get the progress buckets as soon as user clicked Update option
      this.isUpdateBtnPressed = true
    },
    askUserConfirmation: function (event, selectedOperation) {
      this.showConfirmationBox = true
      this.selectedOperation = selectedOperation
      switch (selectedOperation) {
        case 'delete_buckets':
          this.prefixString = 'Are you sure you want to delete all '
          this.postfixString = 'progress bucket(s) from \'' + this.selectedGroupObj.GroupName + '\' group?'
          break
        case 'delete_certificate':
          this.prefixString = 'Are you sure you want to delete '
          this.postfixString = 'added certificate?'
          break
      }
    },
    updateShowEditGroupOverlayFlag: function (event, flagToUpdate) {
      this.$emit('showEditGroupOverlay', flagToUpdate)
    },
    setDefaultValues: function () {
      this.groupObj.GroupId = this.selectedGroupObj.GroupId
      this.groupObj.GroupName = this.selectedGroupObj.GroupName
      this.groupObj.M365Enabled = false // this.selectedGroupObj.M365Enabled
      this.groupObj.M365CourseMasterId = this.selectedGroupObj.M365CourseMasterId === constants.Empty_Guid ? null : this.selectedGroupObj.M365CourseMasterId
      this.groupObj.ProgressBuckets = this.selectedGroupObj.ProgressBuckets
      this.groupObj.IsPublic = this.selectedGroupObj.IsPublic
      this.groupObj.Certificate = this.selectedGroupObj.Certificate
      this.groupObj.ShowUnreleasedModuleMessage = this.selectedGroupObj.ShowUnreleasedModuleMessage
      this.groupObj.UnreleasedModuleMessage = this.selectedGroupObj.UnreleasedModuleMessage
      this.groupObj.MaxElectiveEnrollmentCount = (this.selectedGroupObj.MaxElectiveEnrollmentCount !== undefined && this.selectedGroupObj.MaxElectiveEnrollmentCount !== 'undefined' && this.selectedGroupObj.MaxElectiveEnrollmentCount !== null && this.selectedGroupObj.MaxElectiveEnrollmentCount !== 'null' && this.selectedGroupObj.MaxElectiveEnrollmentCount !== '') ? parseInt(this.selectedGroupObj.MaxElectiveEnrollmentCount) : 0
      this.groupObj.CohortName = (this.selectedGroupObj.CohortName !== undefined && this.selectedGroupObj.CohortName !== 'undefined' && this.selectedGroupObj.CohortName !== null && this.selectedGroupObj.CohortName !== 'null' && this.selectedGroupObj.CohortName !== '') ? this.selectedGroupObj.CohortName : ''
      this.setLeapsDefaultValues()
    },
    setLeapsDefaultValues: function () {
      this.groupObj.MinActionCount = this.selectedGroupObj.MinActionCount
      this.groupObj.MaxActionCount = this.selectedGroupObj.MaxActionCount
    },
    emitShowSpinner (value) {
      this.$emit('showSpinner', value)
    },
    updateGroupDetails: function (event) {
      var _this = this
      var storeObj = this.$store
      if (this.selectedGroupObj !== undefined) {
        // AK: Start Showing Spinner (ManageGroup file)
        _this.$emit('showSpinner', true)
        const formData = new FormData()
        // AK: Check wheather user has added Unreleased lesson text? If not then keep it null and set show value to false.
        if (this.groupObj.UnreleasedModuleMessage === undefined || this.groupObj.UnreleasedModuleMessage === 'undefined' || this.groupObj.UnreleasedModuleMessage === null || this.groupObj.UnreleasedModuleMessage === 'null' || this.groupObj.UnreleasedModuleMessage === '') {
          this.groupObj.ShowUnreleasedModuleMessage = false
          this.groupObj.UnreleasedModuleMessage = null
        }
        if (parseInt(this.groupObj.MaxElectiveEnrollmentCount) === 0) {
          this.groupObj.MaxElectiveEnrollmentCount = null
          this.groupObj.CohortName = null
        }
        /*
        this.groupObj.MinActionCount = this.selectedGroupObj.MinActionCount
        this.groupObj.MaxActionCount = this.selectedGroupObj.MaxActionCount
        */
        formData.append('GroupInfo', JSON.stringify(this.groupObj))
        groupService
            .updateGroup(storeObj.state.access_token, formData)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Refresh Group List
                _this.$emit('refreshGroupList', true)
                _this.$emit('showEditGroupOverlay', false)
              } else {
                _this.isUpdateBtnPressed = false
                // AK: Hide Spinner
                _this.$emit('showSpinner', false)
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              _this.isUpdateBtnPressed = false
              _this.$emit('showSpinner', false)
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
      } else {
        console.log(
          'Selected Group Object is NULL hence declined UPDATE Group OPERATION'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      // AK : Do not hide the Update Group Overlay if Warning / Error is issued (Allow user to explicity close it)
      this.$emit('ShowUpdateLesson', true)
      this.showAlertDialog = value
    },
    validateGroupName: function () {
      if (/^(\w+\s?)*\s*$/.test(this.groupObj.GroupName)) {
        return true
      }
      return false
    }
  },
  computed: {
    getExistingCertificateListValue: {
      get: function () {
        return this.existingCertificateList
      },
      set: function (newValue) {
        this.existingCertificateList = newValue
      }
    },
    getGroupCourseListValue: {
      get: function () {
        return this.groupCourseList
      }
    },
    getUnreleasedModuleMessage: {
      get: function () {
        return this.groupObj.UnreleasedModuleMessage
      },
      set: function (newValue) {
        this.groupObj.UnreleasedModuleMessage = newValue
      }
    },
    getMaxElectiveEnrollmentCount: {
      get: function () {
        return this.groupObj.MaxElectiveEnrollmentCount
      },
      set: function (newValue) {
        this.groupObj.MaxElectiveEnrollmentCount = parseInt(newValue)
        if (this.groupObj.MaxElectiveEnrollmentCount === 0) {
          this.groupObj.CohortName = ''
        }
      }
    },
    getCohortName: {
      get: function () {
        return this.groupObj.CohortName
      },
      set: function (newValue) {
        this.groupObj.CohortName = newValue
      }
    },
    getShowUnreleasedModuleMessage: {
      get: function () {
        return this.groupObj.ShowUnreleasedModuleMessage
      },
      set: function (newValue) {
        this.groupObj.ShowUnreleasedModuleMessage = newValue
      }
    },
    groupNameValue: {
      get: function () {
        return this.groupObj.GroupName
      },
      set: function (newValue) {
        this.groupObj.GroupName = newValue
      }
    },
    IsUpdateGroupBtnPressed: {
      get: function () {
        return this.isUpdateBtnPressed
      }
    },
    currentProgressBuckets: {
      get: function () {
        return this.groupObj.ProgressBuckets
      }
    },
    m365EnabledValue: {
      get: function () {
        return this.groupObj.M365Enabled
      },
      set: function (newValue) {
        this.groupObj.M365Enabled = newValue
      }
    },
    getIsPublicValue: {
      get: function () {
        return this.groupObj.IsPublic
      },
      set: function (newValue) {
        this.groupObj.IsPublic = newValue
      }
    },
    getMinActionCountValue: {
      get: function () {
        return this.groupObj.MinActionCount
      },
      set: function (newValue) {
        var pattern = /^-?\d+\.?\d*$/
        if (newValue !== undefined && newValue !== null && newValue !== 'null' && newValue !== '' && pattern.test(newValue)) {
          if (parseInt(newValue) < 0) {
            this.showAlertDialog = true
            this.errorMsg = 'Min Action count must be positive value.'
          } else {
            this.groupObj.MinActionCount = parseInt(newValue)
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'Min Action must be a non empty digit value.'
        }
      }
    },
    getMaxActionCountValue: {
      get: function () {
        return this.groupObj.MaxActionCount
      },
      set: function (newValue) {
        var pattern = /^-?\d+\.?\d*$/
        if (newValue !== undefined && newValue !== null && newValue !== 'null' && newValue !== '' && pattern.test(newValue)) {
          if (parseInt(newValue) < 0) {
            this.showAlertDialog = true
            this.errorMsg = 'Max Action count must be positive value.'
          } else {
            this.groupObj.MaxActionCount = parseInt(newValue)
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'Max Action must be a non empty digit value.'
        }
      }
    }
  },
  watch: {
    getShowUnreleasedModuleMessage: function (newValue, oldValue) {
      this.getUnreleasedModuleMessage = newValue ? this.selectedGroupObj.UnreleasedModuleMessage : ''
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 10%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

/*
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
*/
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.font-size-21px {
  font-size: 21px !important;
}
.text-align-right {
  text-align: right;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.font-size-15px {
  font-size: 14px;
}
.text-align-left {
  text-align: left !important;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.text-color-orange {
  color: #f39c12 !important;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-grey {
  border: 1px solid gainsboro;
}
.padding-top-1-perc {
  padding-top: 1%;
}
.padding-bottom-1-perc {
  padding-bottom: 1%;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-3Perc {
  margin-top: 1%;
}
.padding-top-1Perc {
  padding-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}
.margin-top-2Perc{
  margin-top:2%;
}
.padding-6px-7px {
  padding: 6px 7px;
}
.float-left {
  float: left;
}
.padding-left-0Px {
  padding-left: 0px;
}
.padding-right-0Px {
  padding-right: 0px;
}
.text-color-blue {
  color: blue;
}
.text-decoration-underline {
  text-decoration: underline;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
a:link{
  color: blue !important;
  text-decoration: none !important;
} 
a:visited{
  color: blue !important;
  text-decoration: none !important;
}
a:hover{
  color: blue !important;
  text-decoration: none !important;
}
a:active{
  color: blue !important;
  text-decoration: none !important;
}
a {
  color: blue !important;
  text-decoration: underline !important;
}
.border-top-1px-solid-grey {
  border-top: 1px solid #dddddd;
}
.tooltip1 {
    position: relative !important;
    display: inline-block !important;
    /* border-bottom: 1px dotted black !important; */
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    width: 90px;
    background-color: #696969;
    /* opacity:0.8; */
    color: #fff;
    text-align: left;
    border-radius: 6px;
    padding: 5px 5px;
    font-size: 12px;
    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    top: 107%;
    left: 35%;
    margin-left: -60px;
}
.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1:hover .tooltiptext1 {
    visibility: visible;
}
.height-20Px {
 height:20px; 
}
.width-20Px {
  width:20px;
}
.padding-bottom-3px {
  padding-bottom:3px;
}
</style>


// WEBPACK FOOTER //
// src/components/UpdateGroupDetailsOverlay.vue